import { trainingAPI } from "@api/TrainingAPI";

// The thunks return the response and rethrow an error, so the caller shows the server's message.

export const getDayTargetDay = (date) => () => trainingAPI.getDayTargetDay(date);

export const getDayTargetValues = (date) => () => trainingAPI.getDayTargetValues(date);

export const getDayTargetReferenceValues = (date, source) => () =>
	trainingAPI.getDayTargetReferenceValues(date, source);

export const getDayTargetSuggestions = (date, metricKey, scope) => () =>
	trainingAPI.getDayTargetSuggestions(date, metricKey, scope);

export const saveDayTarget = (date, values, mode) => () =>
	mode === "edit" ? trainingAPI.updateDayTarget(date, values) : trainingAPI.createDayTarget(date, values);

export const deleteDayTarget = (date) => () => trainingAPI.deleteDayTarget(date);
